'use client';
import React from 'react';
import { Flex, Image } from '@chakra-ui/react';
import NextImage from 'next/image';
interface ProductImageProps {
  imageUrl: string;
  name: string;
  imageWidth?: number;
  imageHeight?: number;
}

export const ProductImage = ({ imageUrl, name, imageWidth = 300, imageHeight = 300 }: ProductImageProps) => {
  return (
    <Flex align="center" height="100%" justify="center" width="100%" minWidth="0">
      <Image
        asChild
        alt={name}
        height={imageHeight}
        width={imageWidth}
        objectFit="contain"
        src={imageUrl}
        style={{ mixBlendMode: 'darken' }}
        maxWidth="100%"
        maxHeight="100%"
      >
        <NextImage src={imageUrl} alt={name} width={imageWidth} height={imageHeight} />
      </Image>
    </Flex>
  );
};
